export const MAX_MOBILE_WIDTH = 768;
export const MAX_DESKTOP_WIDTH = 1024;
export const MAX_DESKTOP_LG = 1440;
